import { NOTIFICATIONS_CONSTANTS } from "../../constants";
import { FormValidationType } from "../../types";

export const formFieldsValidation: FormValidationType = {
  [NOTIFICATIONS_CONSTANTS.READ_ONLY_SITE_NOTIFICATIONS]: {
    required: { value: false },
  },
};
